import { User } from "lucide-react";

import { cn } from "@/lib/utils";

export type AvatarSize = "xs" | "sm" | "lg";

interface AvatarProps {
  initials: string;
  size: AvatarSize;
  testId: string;
  className?: string;
}

const SIZE_CLASSES = {
  xs: "w-7 h-7 text-[10px]",
  sm: "w-8 h-8 text-xs",
  lg: "w-12 h-12 text-base",
} as const;

const ICON_SIZE_CLASSES = {
  xs: "h-4 w-4",
  sm: "h-4 w-4",
  lg: "h-6 w-6",
} as const;

export function Avatar({ initials, size, testId, className }: AvatarProps) {
  return (
    <div
      className={cn(
        "rounded-full bg-surface-inverted flex items-center justify-center text-primary-foreground font-semibold transition-all",
        SIZE_CLASSES[size],
        className,
      )}
      data-testid={testId}
    >
      {initials || <User className={ICON_SIZE_CLASSES[size]} />}
    </div>
  );
}
